module.exports = __WEBPACK_EXTERNAL_MODULE_xlsx__;